export class EntityPropertyNotArrayButSetAsAssociationManyToMany extends Error {
    constructor(entity: any, propertyName: string) {
        super(`Property ${propertyName} of entity ${entity} set as AssociationManyToMany but not array passed!`);

        Object.setPrototypeOf(this, EntityPropertyNotArrayButSetAsAssociationManyToMany.prototype);
    }
}
